<template>
    <div class="content">
        <headers :title='titles'></headers>
        <div class="title">
            <div class="one_div"
                 @click='original'>
                <span :class='{"activity":!index}'>原文</span>
            </div>
            <div @click='questions'>
                <span :class='{"activity":index}'>试题详情</span>
            </div>
        </div>
        <template v-if="!index">
            <div class="content">
                <div class="content-tit"
                     v-if="title">{{title}}</div>
                <div class="list"
                     v-if="content!=''">
                    <p class="text"
                       v-html='c'
                       v-for="c in content"></p>
                </div>
            </div>
        </template>
        <template v-else>
            <div class="content"
                 v-for="(item,index) in list">
                <div class="item_title"
                     v-html="item.title"></div>
                <div class="showBtn"
                     @click="showBtn(item,index)">{{item.btnCon}}<i :class="{'icon_bottom':!item.chooseShow,'icon_top':item.chooseShow}"></i></div>
                <div :class="['item_option',{'item_equal':item.right_answer==option.option}]"
                     v-for="option in item.options"
                     v-if="item.chooseShow">
                    <i>{{option.option}}</i>
                    <p v-html="option.content"></p>
                </div>
            </div>
        </template>
    </div>
</template>

<script type="text/ecmascript-6">
import loading from 'COMPONENTS/base/tealoading.vue';
import noResouse from 'COMPONENTS/noResouse.vue'
import headers from 'COMPONENTS/base/header.vue'

export default {
    data () {
        return {
            titles: '作业预览',
            catalogId: this.$route.query.id || false,//章节id
            reid: this.$route.query.reid,
            next_btn: false,
            numQues: 0,
            index: 0,
            content: '',
            list: [],
            title: null,
            // showBtnCon:'展开选项',
            // chooseShowBtn:false,
        }
    },
    components: {
        loading,
        noResouse,
        headers
    },
    computed: {},
    async created () {
        // let id='';
        let _array = ['A', 'B', 'C', 'D'];
        this.$http.post(API_URL_TASK_API + '/chinese/make/extracurricular_reading_question', { re_id: this.reid }).then(res => {
            if (res.data.response === 'ok') {
                res = res.data;
                let _content = res.data.resource[0].re_content;
                this.content = _content.split('||');
                this.title = res.data.resource[0].re_name;
                res.data.resource.forEach(l => {
                    let _obj = {};
                    _obj.title = l.rd_titledry;
                    _obj.id = l.rd_id;
                    _obj.chooseShow = false;
                    _obj.btnCon = '展开选项';
                    _obj.options = [];
                    _obj.right_answer = l.rd_trueoption;
                    l.rd_options.forEach((option, index) => {
                        let _o = {
                            option: _array[index],
                            content: option
                        }
                        _obj.options.push(_o);
                    })
                    this.list.push(_obj);
                })
                //console.log(this.list)
            }
        })
    },
    methods: {
        original () {
            this.index = 0
        },
        questions () {
            this.index = 1
        },
        showBtn (item, index) {
            item.chooseShow = !item.chooseShow;
            if (item.chooseShow) {
                item.btnCon = '收起选项';
            } else {
                item.btnCon = '展开选项';
            }
            this.list.splice(index, 1, item);
        },
    }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
@import "SRC/assets/scss/common/_mixin";

.title {
    height: 96px / $ppr;
    display: flex;
    display: -webkit-flex;
    justify-content: space-between;
    align-items: center;
    -webkit-justify-content: space-between;
    -webkit-align-items: center;
    background: #fff;
    div {
        display: inline-block;
        width: 50%;
        height: 40px / $ppr;
        text-align: center;
        span {
            min-width: 120px / $ppr;
            max-width: 100%;
            height: 96px / $ppr;
            font-size: 30px / $ppr;
            display: inline-block;
            line-height: 96px / $ppr;
            position: relative;
            top: -34px / $ppr;
            &.activity {
                color: #5e89ef;
                border-bottom: 4px / $ppr solid #5e89ef;
            }
        }
        &.one_div {
            border-right: 1px / $ppr solid #dcdcdc;
        }
    }
}

.content-tit {
    text-align: center;
    font-size: 30px / $ppr;
    color: #333;
    font-weight: bold;
    margin: 60px / $ppr auto 40px / $ppr;
}

.list > p {
    text-align: left;
    text-indent: 2em;
    line-height: 1.5rem;
    // padding-bottom: .75rem;
    padding: 7px / $ppr 25px / $ppr 7px / $ppr;
}

.item_title {
    // line-height: 96px/$ppr;
    line-height: 46px / $ppr;
    background: #fff;
    border-bottom: 1px / $ppr solid #dcdcdc;
    padding: 25px / $ppr 24px / $ppr 25px / $ppr 25px / $ppr;
    margin-top: 24px / $ppr;
}

.item_option {
    line-height: 96px / $ppr;
    // height:96px/$ppr;
    background: #fff;
    border-bottom: 1px / $ppr solid #dcdcdc;
    padding-left: 24px / $ppr;
    position: relative;
    i {
        display: inline-block;
        position: absolute;
        top: 50%;
        left: 0.6rem;
        text-align: center;
        display: inline-block;
        width: 1.25rem;
        height: 1.25rem;
        line-height: 1.25rem;
        border-radius: 50%;
        margin-top: -0.625rem;
        border: 1px / $ppr solid #dcdcdc;
    }
    p {
        display: inline-block;
        width: 14.5rem;
        padding: 0.5rem 0.5rem 0.5rem 2rem;
    }
}

.item_equal {
    i {
        border: 1px / $ppr solid #6c2;
        background: #6c2;
        color: #fff;
    }
    p {
        color: #6c2;
    }
}
.showBtn {
    border-bottom: $line 1px / $ppr solid;
    line-height: 96px / $ppr;
    height: 96px / $ppr;
    color: #5e89ef;
    font-size: 30px / $ppr;
    padding-left: 40px / $ppr;
    position: relative;
    background: #fff;
    i {
        display: block;
        width: 25px / $ppr;
        height: 13px / $ppr;
        position: absolute;
        top: 42px / $ppr;
        left: 170px / $ppr;
    }
    .icon_bottom {
        background: url("./img/icon_open.png") 0 0 no-repeat;
        background-size: 100% 100%;
    }
    .icon_top {
        background: url("./img/icon_close.png") 0 0 no-repeat;
        background-size: 100% 100%;
    }
}
</style>
